export { default } from './UserResponseSynonymTable';
